// extracted by mini-css-extract-plugin
module.exports = {"locationInfo":"OkQJB","locationInfo-title":"_6Ll4A","locationInfo-body":"NM7a4"};